import { AssetMainType } from "../models/asset";
import { CriptoExchangeRateCommand, CurrencyExchangeRateCommand, FundsExchangeRateCommand, IExchangeCommand, StockExchangeRateCommand } from "./exchangeRate";
import { IAuthHttp } from "../hooks/useAuthHttp";

export const ExchangeRateCommandFactory = (): { getInstance: (type: AssetMainType) => (code: string, exchangeDate: Date, authHttp: IAuthHttp, fundType?: "B3" | "CVM") => IExchangeCommand | null } => {
    const getInstance = (type: AssetMainType) => {
        const command = (() => {
            switch (type) {
                case AssetMainType.Cripto:
                    return CriptoExchangeRateCommand;
                case AssetMainType.Currency:
                    return CurrencyExchangeRateCommand;
                case AssetMainType.InvestimentFunds:
                    return FundsExchangeRateCommand;
                case AssetMainType.Stock:
                    return StockExchangeRateCommand;
                default:
                    return null;
            }
        })();

        return (code: string, exchangeDate: Date, authHttp: IAuthHttp, fundType?: "B3" | "CVM") => command ? command(code, exchangeDate, authHttp, fundType) : null;
    }

    return {
        getInstance
    };
}
